import { createPaginatedApiQuery } from "hooks/createPaginatedQuery";
import { getCarrierOrder, getCarrierOrders } from "./calls";
import { createApiQuery } from "hooks/createApiQuery";

export const useCarrierOrders = createPaginatedApiQuery(getCarrierOrders);
export const useCarrierOrder = createApiQuery(getCarrierOrder);
